module.exports = __webpack_public_path__ + "static/img/400x500.ddc39c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/400x500.jpg
// module id = 1345
// module chunks = 4